import usdcCommon from "../common/usdc";

export const USDC = {
  id: 1337,
  height: 2616910,
  ...usdcCommon,
};
